"use client";

import { createContext, useContext, type ReactNode } from "react";

const GenieStageContainerContext = createContext<HTMLElement | null>(null);

export function GenieStageContainerProvider({
  value,
  children,
}: {
  value: HTMLElement | null | undefined;
  children: ReactNode;
}) {
  // Always render the Provider: conditionally swapping Provider <-> Fragment
  // changes the element type at the root of the app subtree, so React
  // unmounted and remounted EVERYTHING on every Genie open/close (losing all
  // local state, e.g. any open dialog). A null value means "no stage" and
  // matches the context default, so dialogs render normally.
  return (
    <GenieStageContainerContext.Provider value={value ?? null}>
      {children}
    </GenieStageContainerContext.Provider>
  );
}

export function useGenieStageContainer(): HTMLElement | null {
  return useContext(GenieStageContainerContext);
}

export const GENIE_INTERACTIVE_SELECTOR =
  "[data-genie-panel],[data-genie-spotlight],[data-genie-toggle]";

export function isInsideGenieUi(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    target.closest(GENIE_INTERACTIVE_SELECTOR) !== null
  );
}
